import { getPluginState } from '../plugin-factory';
export function getAllowAddColumnCustomStep(state) {
  var tablePluginState = getPluginState(state);
  return Boolean(tablePluginState) && Boolean(tablePluginState.pluginConfig.allowAddColumnWithCustomStep);
}